export const listings = [
    {
        "id": "033ce793-ef99-4dd8-92b0-5a097f3bd468",
        "name":"Outdoor Recreation Infrastructure Development Company",
        "price":1050000,
        "currency":"CAD",
        "priceAdjustments":"",
        "description":"Renowned across North America, the business is strongly positioned as a leader in the emerging outdoor recreation market, offering high quality service and education for the communities the projects are based within.",
        "url":"https://omniumbusiness.com/for-sale/",
        "revenue":936820,
        "ebitda":217334,
        "location":"Alberta",
        "province": "AB",
        "naicsCode": "237990",
        "sold":false,
        "featured": true,
        "image": "https://crm.omniumbusiness.com/uploads/gallery/_63.jpg"
    },
    {
        "id": "6806f9e0-20b8-4172-b72a-665561b287cc",
        "name":"Well Established Profitable Mattress Retailer in a Lifestyle Community",
        "price":1298000,
        "currency":"CAD",
        "priceAdjustments":"",
        "description":"Here is your opportunity to acquire a turn-key mattress retailer in Coastal BC.",
        "url":"https://omniumbusiness.com/for-sale/",
        "revenue":1877698,
        "ebitda":363791,
        "location":"Sunshine Coast",
        "province": "BC",
        "naicsCode": "448110",
        "sold":false,
        "featured": true,
        "image": "https://crm.omniumbusiness.com/uploads/gallery/_72.jpg"
    }
]